import isPropValid from "@emotion/is-prop-valid";

export const px = (value: number | string): string =>
  typeof value === "number" ? `${value}px` : value;

export const shouldForwardProp =
  <TProp extends string>(opts?: { ignore?: TProp[] }) =>
  (prop: TProp): boolean =>
    isPropValid(prop) && !opts?.ignore?.includes(prop);
